import "./Register.scss"
import SignupComp from "../../components/Signup/Signup";

const Register = () => {
  return (
    <div className="register">
      <SignupComp />
    </div>
  );
};

export default Register;
